/*
 * Copyright 2025 Intuition Robotics ltd
 */
export const HeaderKey_SessionId = "x-session-id";
export const QueryParam_Email = "userEmail";
export const QueryParam_Token = HeaderKey_SessionId;
export const QueryParam_RedirectUrl = "redirectUrl";
export const HeaderKey_EnvVersion = "x-env-version";
export const HeaderKey_CurrentPage = "current-page";
export const HeaderKey_Secret = "x-secret";
export const HeaderKey_Proxy = "x-proxy";

export type Type_Login = {
	loginUrl: string
};

export type LoginContext = {
	[QueryParam_RedirectUrl]: string
};

export type Response_CaregiverToken = {
	token: string
};

export type PostAssertBody = {
	SAMLResponse: string
	RelayState: string
};